// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BjKGu","fullView":"styles_fullView__3rQmK"};